<template>
    <div>
        <ValidationObserver ref="form" v-slot="{ invalid, validate, dirty }">
            <form
                autocomplete="off"
                @submit.prevent="validate().then(updateMe)"
            >
                <div class="row">
                    <div class="col-md-4">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="First Name"
                            rules="required"
                        >
                            <base-input
                                id="firstName"
                                v-model.trim="user.first_name"
                                name="fname"
                                autocomplete="off"
                                type="text"
                                label="First Name"
                                placeholder="First Name"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Last Name"
                            rules="required"
                        >
                            <base-input
                                id="lastName"
                                v-model.trim="user.last_name"
                                name="lname"
                                autocomplete="off"
                                type="text"
                                label="Last Name"
                                placeholder="Last Name"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Password"
                            :rules="`min:${passwordMinLength}`"
                        >
                            <base-input
                                id="password"
                                v-model.trim="user.password"
                                unlock
                                name="password"
                                type="password"
                                label="Password"
                                placeholder="********"
                                autocomplete="new-password"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                </div>
                <base-button
                    id="updateAccount"
                    :disabled="invalid || !dirty"
                    native-type="submit"
                    type="primary"
                    class="btn-fill"
                >
                    Update Account
                </base-button>
            </form>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: "EditAccountForm",
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        me: {
            type: Object,
            required: true,
        },
        passwordMinLength: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            user: { ...this.me },
        };
    },
    watch: {
        me(update) {
            this.user = { ...update };
        },
    },
    methods: {
        updateMe() {
            this.$emit("updateMe", {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                password: this.user.password,
            });
            this.$refs.form.reset();
        },
    },
};
</script>
